/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as CommunicationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.communication.updateTemplate'

export { $nsid }

/** Administrative action to update an existing communication template. Allows passing partial fields to patch specific fields only. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    id: l.string(),
    name: l.optional(l.string()),
    lang: l.optional(l.string({ format: 'language' })),
    contentMarkdown: l.optional(l.string()),
    subject: l.optional(l.string()),
    updatedBy: l.optional(l.string({ format: 'did' })),
    disabled: l.optional(l.boolean()),
  }),
  l.payload(
    'application/json',
    l.ref<CommunicationDefs.TemplateView>(
      (() => CommunicationDefs.templateView) as any,
    ),
  ),
  ['DuplicateTemplateName'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
